import { createContext } from "react";
import * as WS from '../webServices/cyMyManager'

export type GlobalContextVarType = {
    esercente: WS.Plus.IF.Esercente | undefined;
}

export type GlobalContextData = {
    vars: GlobalContextVarType;
    update: (data: GlobalContextVarType) => void;
}

export const globalVar: GlobalContextVarType = {
    esercente: undefined
}

export const globalData: GlobalContextData = {
    vars: globalVar,
    update: (data) => { }
}

export const GetGlobalContext = createContext<GlobalContextData>(globalData);

export const GlobalContextProvider = GetGlobalContext.Provider;
